import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';

export const GET_GIFTCARD_LIST_REQUEST = 'GET_GIFTCARD_LIST_REQUEST';
export const GET_GIFTCARD_LIST_ERROR = 'GET_GIFTCARD_LIST_ERROR';
export const GET_GIFTCARD_LIST_SUCCESS = 'GET_GIFTCARD_LIST_SUCCESS';

export const ADD_GIFTCARD_REQUEST = 'ADD_GIFTCARD_REQUEST';
export const ADD_GIFTCARD_ERROR = 'ADD_GIFTCARD_ERROR';
export const ADD_GIFTCARD_SUCCESS = 'ADD_GIFTCARD_SUCCESS';

export const BUY_GIFTCARD_REQUEST = 'BUY_GIFTCARD_REQUEST';
export const BUY_GIFTCARD_ERROR = 'BUY_GIFTCARD_ERROR';
export const BUY_GIFTCARD_SUCCESS = 'BUY_GIFTCARD_SUCCESS';

export const CHECK_BALANCE_REQUEST = 'CHECK_BALANCE_REQUEST';
export const CHECK_BALANCE_ERROR = 'CHECK_BALANCE_ERROR';
export const CHECK_BALANCE_SUCCESS = 'CHECK_BALANCE_SUCCESS';

export const GET_GIFTCARD_DENOMINATION_REQUEST = 'GET_GIFTCARD_DENOMINATION_REQUEST';
export const GET_GIFTCARD_DENOMINATION_ERROR = 'GET_GIFTCARD_DENOMINATION_ERROR';
export const GET_GIFTCARD_DENOMINATION_SUCCESS = 'GET_GIFTCARD_DENOMINATION_SUCCESS';

export const GET_STATE_LIST_REQUEST = 'GET_STATE_LIST_REQUEST';
export const GET_STATE_LIST_ERROR = 'GET_STATE_LIST_ERROR';
export const GET_STATE_LIST_SUCCESS = 'GET_STATE_LIST_SUCCESS';

export const SEND_NOTIFICATION_REQUEST = 'SEND_NOTIFICATION_REQUEST';
export const SEND_NOTIFICATION_ERROR = 'SEND_NOTIFICATION_ERROR';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';

export const ADD_MAILER_CARD_REQUEST = 'ADD_MAILER_CARD_REQUEST';
export const ADD_MAILER_CARD_ERROR = 'ADD_MAILER_CARD_ERROR';
export const ADD_MAILER_CARD_SUCCESS = 'ADD_MAILER_CARD_SUCCESS';

export const CLEAR_GIFTCARD_BALANCE = 'CLEAR_GIFTCARD_BALANCE';
export const CLEAR_CHECK_BALANCE = 'CLEAR_CHECK_BALANCE';
export const CLEAR_MAILER_BALANCE = 'CLEAR_MAILER_BALANCE';
export const UPDATE_GIFTCARD_LIST = 'UPDATE_GIFTCARD_LIST';

export function clearGiftcardBalanceAction() {
	return { type: CLEAR_GIFTCARD_BALANCE };
}

export function clearMailerBalanceAction() {
	return { type: CLEAR_MAILER_BALANCE };
}

export function clearCheckBalanceAction() {
	return { type: CLEAR_CHECK_BALANCE };
}

export function updateGiftCardListAction(data) {
	return { type: UPDATE_GIFTCARD_LIST, data };
}

export function getGiftCardListRequestAction() {
	return { type: GET_GIFTCARD_LIST_REQUEST };
}

export function getGiftCardListErrorAction(error) {
	return { type: GET_GIFTCARD_LIST_ERROR, error };
}

export function getGiftCardListSuccessAction(data) {
	return { type: GET_GIFTCARD_LIST_SUCCESS, data };
}

export function addGiftCardRequestAction() {
	return { type: ADD_GIFTCARD_REQUEST };
}

export function addGiftCardErrorAction(error) {
	return { type: ADD_GIFTCARD_ERROR, error };
}

export function addGiftCardSuccessAction(data) {
	return { type: ADD_GIFTCARD_SUCCESS, data };
}

export function buyGiftCardRequestAction() {
	return { type: BUY_GIFTCARD_REQUEST };
}

export function buyGiftCardErrorAction(error) {
	return { type: BUY_GIFTCARD_ERROR, error };
}

export function buyGiftCardSuccessAction(data) {
	return { type: BUY_GIFTCARD_SUCCESS, data };
}

export function checkBalanceRequestAction() {
	return { type: CHECK_BALANCE_REQUEST };
}

export function checkBalanceErrorAction(error) {
	return { type: CHECK_BALANCE_ERROR, error };
}

export function checkBalanceSuccessAction(data) {
	return { type: CHECK_BALANCE_SUCCESS, data };
}

export function getDenominationRequestAction() {
	return { type: GET_GIFTCARD_DENOMINATION_REQUEST };
}

export function getDenominationErrorAction(error) {
	return { type: GET_GIFTCARD_DENOMINATION_ERROR, error };
}

export function getDenominationSuccessAction(data) {
	return { type: GET_GIFTCARD_DENOMINATION_SUCCESS, data };
}

export function getStateListRequestAction() {
	return { type: GET_STATE_LIST_REQUEST };
}

export function getStateListErrorAction(error) {
	return { type: GET_STATE_LIST_ERROR, error };
}

export function getStateListSuccessAction(data) {
	return { type: GET_STATE_LIST_SUCCESS, data };
}

export function sendNotificationRequestAction() {
	return { type: SEND_NOTIFICATION_REQUEST };
}

export function sendNotificationErrorAction(error) {
	return { type: SEND_NOTIFICATION_ERROR, error };
}

export function sendNotificationSuccessAction(data) {
	return { type: SEND_NOTIFICATION_SUCCESS, data };
}

export function addMailerCardRequestAction() {
	return { type: ADD_MAILER_CARD_REQUEST };
}

export function addMailerCardErrorAction(error) {
	return { type: ADD_MAILER_CARD_ERROR, error };
}

export function addMailerCardSuccessAction(data) {
	return { type: ADD_MAILER_CARD_SUCCESS, data };
}

export function getGiftCardListAction() {
	return (dispatch, getState) => {
		dispatch(getGiftCardListRequestAction());
		ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/wallet/egv/active',
				headers: headers
			})
		)
			.then(data => {
				return dispatch(getGiftCardListSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(getGiftCardListErrorAction(err));
			});
	};
}

export function addGiftCardAction(payload) {
	return (dispatch, getState) => {
		dispatch(addGiftCardRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/wallet/egv/link',
				acceptErrors: true,
				headers: headers
			}),
			payload
		)
			.then(data => {
				return dispatch(addGiftCardSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				dispatch(addGiftCardErrorAction(err));
			});
	};
}

export function checkBalanceAction(payload) {
	return (dispatch, getState) => {
		dispatch(checkBalanceRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/egv/balance',
				headers: headers
			}),
			payload
		)
			.then(data => {
				return dispatch(checkBalanceSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(checkBalanceErrorAction(err));
			});
	};
}

export function buyGiftCardAction(payload, requestHeaders = {}) {
	const payloadData = Object.assign({}, payload, {
		checkoutType: 'EGV',
		egvRequests: payload
	});
	return (dispatch, getState) => {
		dispatch(buyGiftCardRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/5/checkout',
				acceptErrors: true,
				headers: headers
			}),
			payloadData
		)
			.then(data => {
				return dispatch(buyGiftCardSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(buyGiftCardErrorAction(err['RESPONSE']));
			});
	};
}

export function getDenominationAction() {
	return (dispatch, getState) => {
		dispatch(getDenominationRequestAction());
		ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/egv/denominations',
				headers: headers
			})
		)
			.then(data => {
				return dispatch(getDenominationSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(getDenominationErrorAction(err));
			});
	};
}

export function getStateListAction() {
	return (dispatch, getState) => {
		dispatch(getStateListRequestAction());
		ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/egv/locations',
				headers: headers
			})
		)
			.then(data => {
				return dispatch(getStateListSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(getStateListErrorAction(err));
			});
	};
}

export function sendNotificationAction(payload) {
	return (dispatch, getState) => {
		dispatch(sendNotificationRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/egv/send-notification',
				acceptErrors: true,
				headers: headers
			}),
			payload
		)
			.then(data => {
				return dispatch(sendNotificationSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(sendNotificationErrorAction(err));
			});
	};
}

export function addMailerCardAction(payload) {
	return (dispatch, getState) => {
		dispatch(addMailerCardRequestAction());
		ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/wallet/egv/batch-link',
				acceptErrors: true,
				headers: headers
			}),
			payload
		)
			.then(data => {
				return dispatch(addMailerCardSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				return dispatch(addMailerCardErrorAction(err));
			});
	};
}
